import styled from "styled-components";


export const BannerSection = styled.section`
    width: 100%;
    position: relative;
    margin-bottom: 30%;

    display: flex;
`;

export const Background = styled.img`
    width: 100%;
    position: absolute;
    z-index: -2;

    @media screen and (min-width: 320px) and (max-width: 480px){
        bottom: -50%;
    }
`;

export const BannerContent = styled.aside`
    width: ${props => props.wd}%;
    margin: 5% 0 0 12%;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
   
    @media screen and (min-width: 320px) and (max-width: 480px){
        margin: 0 5%;
    }

`;